/* eslint-disable class-methods-use-this */
import { CreateTenantInput } from './dto/createTenantInput';
import { EntityDto } from '../dto/entityDto';
import { GetAllTenantOutput } from './dto/getAllTenantOutput';
import { PagedResultDto } from '../dto/pagedResultDto';
import { PagedTenantResultRequestDto } from './dto/PagedTenantResultRequestDto';
import { UpdateTenantInput } from './dto/updateTenantInput';
import UpdateTenantOutput from './dto/updateTenantOutput';
import http from '../httpService';
import { TenantModel } from '@models';
import { InformationChangeRequest, TenantBankAccount, UpdateTenantBankAccount } from './dto/tenantProfile';

class TenantService {
  public async create(createTenantInput: CreateTenantInput) {
    const result = await http.post('api/services/app/Tenant/Create', createTenantInput);
    return result.data.result;
  }

  public async delete(entityDto: EntityDto) {
    const result = await http.delete('api/services/app/Tenant/Delete', { params: entityDto });
    return result.data;
  }

  public async get(entityDto: EntityDto): Promise<TenantModel> {
    const result = await http.get('api/services/app/Tenant/Get', { params: entityDto });
    return result.data.result;
  }

  public async getBankAccount(entityDto: EntityDto): Promise<TenantBankAccount> {
    const result = await http.get('api/services/app/TenantBankAccount/Get', { params: entityDto });
    return result.data.result;
  }

  public async createOrUpdateBankAccount(updateTenantInput: UpdateTenantBankAccount) {
    const result = await http.put('api/services/app/TenantBankAccount/Update', updateTenantInput);
    return result.data.result;
  }

  public async getAll(
    pagedFilterAndSortedRequest: PagedTenantResultRequestDto
  ): Promise<PagedResultDto<GetAllTenantOutput>> {
    const result = await http.get('api/services/app/Tenant/GetAll', {
      params: pagedFilterAndSortedRequest,
    });
    return result.data.result;
  }

  public async update(updateTenantInput: UpdateTenantInput): Promise<UpdateTenantOutput> {
    const result = await http.put('api/services/app/Tenant/Update', updateTenantInput);
    return result.data.result;
  }

  public async informationChangeRequest(input: InformationChangeRequest) {
    await http.post('api/services/app/Tenant/InformationChangeRequest', input);
  }
}

export default new TenantService();
